// extracted by mini-css-extract-plugin
module.exports = {"Clock":"Clock_Clock__iFXs_","time":"Clock_time__zEH5z"};